export const promoBannerQueryKeys = {
  all: ['promo-banners'] as const,
};
